import { motion } from "framer-motion";
import { useState, useEffect } from 'react';

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] },
    }),
};

const LA_TZ = 'America/Los_Angeles';

/** ISO 8601 calendar date (YYYY-MM-DD) in LA — the usual unambiguous “scientific” / API date form. Not BCE; BCE is only for years before 1 CE. */
const laDatePartsFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: LA_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});

function formatLaIsoDate(now) {
    const parts = laDatePartsFmt.formatToParts(now);
    const byType = Object.fromEntries(
        parts.filter((p) => p.type !== 'literal').map((p) => [p.type, p.value])
    );
    return `${byType.year}-${byType.month}-${byType.day}`;
}

const laTimeFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: LA_TZ,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
    hour12: true,
});

function formatLaDateTime(now) {
    return `${formatLaIsoDate(now)} - ${laTimeFmt.format(now)}`;
}

export default function HomepageHeroSection() {
    const [currentDateTime, setCurrentDateTime] = useState('');

    useEffect(() => {
        const tick = () => {
            setCurrentDateTime(formatLaDateTime(new Date()));
        };
        tick();
        const timer = setInterval(tick, 50);
        return () => clearInterval(timer);
    }, []);


    return (
        <section className="relative min-h-[90vh] flex items-center justify-center px-6 lg:px-8 overflow-hidden select-none">
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-accent/[0.03] blur-[120px]" />
                <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] rounded-full bg-indigo-500/[0.02] blur-[100px]" />
            </div>

            <div className="relative mx-auto max-w-3xl text-center pt-20">
                <motion.div
                    initial="offscreen"
                    whileInView="onscreen"
                    variants={fadeUp}
                    viewport={{ once: true, amount: 0 }}
                >
                    <div className="relative inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border border-gray-800 rounded-full px-6 py-2 bg-black/50 backdrop-blur-sm mb-8 max-w-[min(100%,36rem)]">
                        <span className="text-sm font-outfit text-gray-400">🌎</span>
                        <span className="text-gray-700">|</span>
                        <span className="text-sm font-mono tabular-nums text-accent text-center">{currentDateTime}</span>
                    </div>
                </motion.div>

                <motion.h1
                    custom={1}
                    initial="hidden"
                    animate="visible"
                    variants={fadeUp}
                    className="font-syne text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-text-primary leading-[1.1]"
                >
                    Till Time Ends{' '}
                    <br className="hidden sm:block" />
                    {/* <span className="text-accent">Skip the hiring.</span> */}
                </motion.h1>
            </div>
        </section>
    );
}
